import { Component, Input, TemplateRef, inject, CUSTOM_ELEMENTS_SCHEMA, ContentChild } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { AppButton } from "../app-button/app-button";

@Component({
  selector: 'app-section-header',
  standalone: true,
  imports: [CommonModule, AppButton],
  templateUrl: './app-section-header.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppSectionHeader {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() icon: string = '';
  @Input() showBack: boolean = false;

  @Input() metricsTemplate?: TemplateRef<any>;
  @Input() extraHeaderTemplate?: TemplateRef<any>;

  @ContentChild('metricsTemplate') contentMetrics?: TemplateRef<any>;
  @ContentChild('extraHeaderTemplate') contentExtra?: TemplateRef<any>;

  get effectiveMetrics() { return this.metricsTemplate || this.contentMetrics; }
  get effectiveExtra() { return this.extraHeaderTemplate || this.contentExtra; }

  private location = inject(Location);

  goBack() {
    this.location.back();
  }
}
